import axios from './api';
import { getQueryData, getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/PreProcessedDocs';

export const getPreProcessedDocuments = async ({ page, size, filters }) => {
  return axios
    .get(endPoint.concat(getQueryData(page, size, filters)), {})
    .then((response) => response)
    .catch((error) => error.response);
};
export const updatePreProcessedDocument = async (id, body) => {
  return axios.put(endPoint.concat('/', id), body, {});
};
export const deletePreProcessedDocument = async (id) =>
  axios
    .delete(endPoint.concat('/', id), {})
    .then((response) => response)
    .catch((error) => error.response);
